export default __webpack_public_path__ + "static/media/finance.0e729646.png";